import { EnterpriseLearnerProfileImportOperationsV1NaptimeResource } from './__generated__/EnterpriseLearnerProfileImportOperationsV1';

class EnterpriseLearnerProfileImportOperations extends EnterpriseLearnerProfileImportOperationsV1NaptimeResource {
  static RESOURCE_NAME = 'enterpriseLearnerProfileImportOperations.v1' as const;
}

export default EnterpriseLearnerProfileImportOperations;
